webpackJsonp([37],{

/***/ "8AaZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _actionTypes = __webpack_require__("EA8k");

var types = _interopRequireWildcard(_actionTypes);

var _InternalLink = __webpack_require__("XSs2");

var _InternalLink2 = _interopRequireDefault(_InternalLink);

var _Link = __webpack_require__("ImdF");

var _Link2 = _interopRequireDefault(_Link);

var _ContentWrapper = __webpack_require__("yfaX");

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColoringOptions = function ColoringOptions() {

    return _react2.default.createElement(
        'article',
        { about: '/faq/recoloring', 'typeof': 'schema:WebPage' },
        _react2.default.createElement(
            _ContentWrapper2.default,
            null,
            _react2.default.createElement(
                'h3',
                null,
                'Wie \xE4ndere ich die Farben meines Designerst\xFCcks'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Ja, richtig gelesen. Bei www.schnoffle.de kannst Du Dein Designerst\xFCck in Deinen Farben umsetzen. Du kannst also den Stoff f\xFCr Deinen Lieblingsschnitt in einem Farbton f\xE4rben oder einzelne und sogar alle Farben spezifisch festlegen. Jetzt ist es problemlos m\xF6glich, Deinen eigenen Stoff in den f\xFCr Dich passenden Farben zu bekommen.'
            ),
            _react2.default.createElement(
                'h3',
                null,
                'Aber: Traue niemals Deinem Bildschirm!'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Auf Smartphone, Tablet , PC usw. sehen die Farben oft anders aus. Wenn Du es genau brauchst, musst Du mit einer ',
                _react2.default.createElement(
                    _InternalLink2.default,
                    {
                        to: { type: types.NAVIGATED_TO_COLORSWATCHES_CART_FORM },
                        target: '_blank' },
                    ' gedruckten Farbkarte'
                ),
                ' arbeiten. Wenn es Dir ann\xE4hernd reicht, leg los und mach Dir keinen Kopf.'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Du hast verschiedene M\xF6glichkeiten f\xFCr die \xC4nderung der Farbe.'
            ),
            _react2.default.createElement(
                'h3',
                null,
                '1) Einzelne Farben ersetzen'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Ein Klick auf das entsprechende Farbfeld er\xF6ffnet Dir eine riesige Auswahl an Farbm\xF6glichkeiten. \xC4ndere einfach das Blau in Rot und fertig ist das Stoffschwesterchen:'
            ),
            _react2.default.createElement('img', {
                src: '//d2k02hhj0n6fcf.cloudfront.net/images/colorchange.png',
                alt: '' }),
            _react2.default.createElement(
                'h4',
                null,
                'Woher weiss ich, wie die Farben aussehen?'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Angenommen Du m\xF6chtest Deinen Stoff an bereits vorliegende Farben anpassen. Seien es z.B. Farben von Deinen Standardb\xFCndchen oder Uni-Stoffen bei Dir Zuhause, eine vorhandene Hose oder Taschen, die eine perfekte Kombifarbe f\xFCr Dein neue N\xE4hprojekt erfordern.'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Dann bieten wir Dir eine',
                _react2.default.createElement(
                    _InternalLink2.default,
                    {
                        to: { type: types.NAVIGATED_TO_COLORSWATCHES_CART_FORM },
                        target: '_blank' },
                    ' Farbkarte mit fertig bedruckten Farben + Farbcode'
                ),
                '. Diese Stofffarben gleichst Du Zuhause mit vorliegenden Farben ab. Z.B. dem Gr\xFCnton vom neuen Rock f\xFCr passenden Blusenstoff. Nimm entsprechenden Farbcode von der Farbkarte und trage ihn ein. Dein Stoffmuster f\xE4rbt sich und wird in Deiner Wunschfarbe von Deiner Farbkarte passgenau produziert.'
            ),
            _react2.default.createElement('img', {
                src: '//d2k02hhj0n6fcf.cloudfront.net/images/colorswatch.jpg',
                alt: '' }),
            _react2.default.createElement(
                'h4',
                null,
                'Wie stimme ich verschiedene Stoffe aufeinander ab?'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Achte auf die Farbcodes und nutze identische Farben in den verschiedenen Stoffmustern. Damit bekommst Du immer farblich identische Stoffe - alles aus einem Guss. Deine Farben. Dein Stoff. Dein Unikat. Dein Designerst\xFCck.'
            ),
            _react2.default.createElement('img', {
                src: '//d2k02hhj0n6fcf.cloudfront.net/images/colorcollection.jpg',
                alt: '' }),
            _react2.default.createElement(
                'h4',
                null,
                'Ich sehe keine K\xE4stchen mit Farbcode?'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Manchmal hat ein Stoff-Motive einfach zu viele Farben um es individuell einzuf\xE4rben. Dann bleiben nur die Schieberegler'
            ),
            _react2.default.createElement(
                'h3',
                null,
                '2) Schieberegler f\xFCr Farbvarianten'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Benutze die Schieberegler um ein Motiv harmonisch in einem Farbton einzuf\xE4rben.'
            ),
            _react2.default.createElement(
                'h4',
                null,
                'Einf\xE4rben'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Damit kannst Du ALLE Farben gleichm\xE4\xDFig harmonisch \xE4ndern und eine ureigene Farbwelt von dem Muster gestalten.'
            ),
            _react2.default.createElement('img', {
                src: '//d2k02hhj0n6fcf.cloudfront.net/images/colorize.png',
                alt: '' }),
            _react2.default.createElement(
                'h4',
                null,
                'S\xE4ttigung'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Wenn Du eher kr\xE4ftige und sehr satte Farben liebst, wirst Du merken, dass Dein Stoff mit dem Regler nach rechts immer kr\xE4ftigere Farben annimmt. Schiebst Du ihn nach links, verliert er mehr und mehr von den Farben bis erschlie\xDFelich nur noch graue T\xF6ne hat.'
            ),
            _react2.default.createElement('img', {
                src: '//d2k02hhj0n6fcf.cloudfront.net/images/saturation.png',
                alt: '' }),
            _react2.default.createElement(
                'h4',
                null,
                'Helligkeit'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Hier kannst Du den Kissen-Stoff auf einer Skala von ganz schwarz (Schieberegler ganz nach links) bis komplett weiss (Schiebereglern ganz nach rechts) ver\xE4ndern.'
            ),
            _react2.default.createElement('img', { src: '//d2k02hhj0n6fcf.cloudfront.net/images/brightness.png',
                alt: '' }),
            _react2.default.createElement(
                'p',
                null,
                'Du kannst Dir diese ',
                _react2.default.createElement(
                    _Link2.default,
                    {
                        to: '//d2k02hhj0n6fcf.cloudfront.net/images/Farben_FAQ.pdf' },
                    'Anleitung hier als PDF herunterladen'
                ),
                '.'
            ),
            _react2.default.createElement('p', null)
        )
    );
};

exports.default = ColoringOptions;

/***/ }),

/***/ "9N07":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _faqColoringOptions = __webpack_require__("8AaZ");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_faqColoringOptions).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "ImdF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _StyledLink = __webpack_require__("K4Q2");

var _StyledLink2 = _interopRequireDefault(_StyledLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Link = function Link(_ref) {
    var title = _ref.title,
        to = _ref.to,
        children = _ref.children,
        props = _objectWithoutProperties(_ref, ['title', 'to', 'children']);

    return _react2.default.createElement(
        _StyledLink2.default,
        _extends({
            title: title,
            href: to || '#' }, props),
        children
    );
};

exports.default = Link;

/***/ }),

/***/ "L4iW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(__webpack_require__("P4HR"));

/***/ }),

/***/ "P4HR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _warning = _interopRequireDefault(__webpack_require__("mG8X"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _extends2.default)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes.default.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes.default.bool
} : {};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPaper'
})(Paper);

exports.default = _default;

/***/ }),

/***/ "yfaX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Paper = __webpack_require__("L4iW");

var _Paper2 = _interopRequireDefault(_Paper);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentWrapper = (0, _styledComponents2.default)(_Paper2.default).withConfig({
  displayName: 'ContentWrapper',
  componentId: 'sc-1b74oo9-0'
})(['\n  margin: ', ' 0;\n  padding: ', ';\n  position: relative;\n    \n    & p {\n      line-height: 1.61em;\n      margin-bottom: ', ';\n      max-width: ', ';\n    }\n\n    & h1, h2, h3, h4, h5, h6 {\n      margin: ', ' 0 ', ';\n    }\n    \n    & img {\n      max-width: 100%;\n    }\n\n'], function (props) {
  return props.theme.space[12];
}, function (props) {
  return props.theme.space[10];
}, function (props) {
  return props.theme.space[9];
}, function (props) {
  return props.theme.space[23];
}, function (props) {
  return props.theme.space[7];
}, function (props) {
  return props.theme.space[12];
});

exports.default = ContentWrapper;

/***/ })

});


// WEBPACK FOOTER //
// async/defaq-coloring-options.666252946fddc6d2d312.js